import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import { REGISTER_LOCALE_IDS, LOCALE_MODULES } from './app/core/constants/date-formats';

Object.entries(REGISTER_LOCALE_IDS).forEach(([key, localeId]) => {
  const localeModule = LOCALE_MODULES[key];
  if (localeModule) registerLocaleData(localeModule, localeId);
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
